import { TreeLikeFlatNode, TreeLikeNode } from '@src/suite/common/data-models/search-results/search-results';

export const getNodeLevel = ({ level }: TreeLikeFlatNode) => {
    return level;
};

// Function that determines whether a flat node is expandable or not
export const getIsNodeExpandable = ({ hasChildren }: TreeLikeFlatNode) => {
    return hasChildren;
};

// Function that returns a nested node's list of children
export const getNodeChildren = ({ children }: TreeLikeNode) => {
    return children;
};

// Function that maps a nested node to a flat node
export const nodeTransformer = (node: TreeLikeNode, level: number): TreeLikeFlatNode => {
    return {
        id: node.id,
        nodeType: node.nodeType,
        label: node.label,
        uniqueId: node.uniqueId,
        index: node.index,
        itemsCount: node.itemsCount,
        level,
        hasChildren: node?.children?.length > 0,
        object: node.object,
        nodeLastInGroup: node.nodeLastInGroup,
        nodeFirstInGroup: node.nodeFirstInGroup,
        linkedRecordType: node?.linkedRecordType,
        isMetadata: node?.isMetadata,
        isNewItems: node?.isNewItems,
        cost: node?.cost,
    };
};
